(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1982],{

/***/ 24414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ EmailLogin; }
/* harmony export */ });
/* harmony import */ var _home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(16835);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50319);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(88641);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(24824);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50261);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2453);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(42561);
/* harmony import */ var _shared_button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61373);
/* harmony import */ var _contexts_authToken__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43911);
/* harmony import */ var graphql_generated_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13492);
/* harmony import */ var redux_flash_messages__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64515);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












var FormItem = antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Item */ .Z.Item;
var validateMessages = {
  // eslint-disable-next-line no-template-curly-in-string
  required: '${label} is required!',
  types: {
    // eslint-disable-next-line no-template-curly-in-string
    email: '${label} is not valid!'
  }
};
function EmailLogin(_ref) {
  var callbackbeforeRedirect = _ref.callbackbeforeRedirect;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''),
      userEmail = _useState[0],
      setuserEmail = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(''),
      userPassword = _useState2[0],
      setuserPassword = _useState2[1];

  var _useMutation = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_9__/* .useMutation */ .D)(graphql_generated_types__WEBPACK_IMPORTED_MODULE_5__/* .Login_MutationDocument */ .Q0),
      _useMutation2 = (0,_home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_useMutation, 2),
      Login = _useMutation2[0],
      data = _useMutation2[1].data;

  if (data) {
    if (callbackbeforeRedirect) {
      callbackbeforeRedirect();
    } else {
      (0,redux_flash_messages__WEBPACK_IMPORTED_MODULE_6__.addSuccess)({
        text: 'Registration Successfull'
      });
      next_router__WEBPACK_IMPORTED_MODULE_2___default().push('/');
    }
  }

  var token = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_contexts_authToken__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z);
  var setToken = token.setToken;

  var _useMutation3 = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_9__/* .useMutation */ .D)(graphql_generated_types__WEBPACK_IMPORTED_MODULE_5__/* .Update_UserDocument */ .xU),
      _useMutation4 = (0,_home_circleci_project_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_useMutation3, 1),
      updateUser = _useMutation4[0];

  var formItemLayout = {
    wrapperCol: {
      span: 32
    }
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(antd__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, _objectSpread(_objectSpread({
      name: "basic",
      layout: "vertical"
    }, formItemLayout), {}, {
      className: "login-form",
      onFinish: function onFinish() {
        Login({
          variables: {
            input: {
              identifier: userEmail,
              password: userPassword
            }
          }
        }).then(function (res) {
          localStorage.setItem('authToken', res.data.login.jwt);
          localStorage.setItem('userEmail', res.data.login.user.email);
          localStorage.setItem('userId', res.data.login.user.id);
          setToken(res.data.login.jwt);
          updateUser({
            context: {
              headers: {
                Authorization: "Bearer ".concat(res.data.login.jwt)
              }
            }
          })["catch"](function (err) {
            antd__WEBPACK_IMPORTED_MODULE_12__/* ["default"].error */ .ZP.error('---update err----', err);
          });
        })["catch"](function (error) {
          if (error.message === 'GraphQL error: Bad Request') {
            antd__WEBPACK_IMPORTED_MODULE_12__/* ["default"].error */ .ZP.error('Invalid Email or Password');
          } else {
            antd__WEBPACK_IMPORTED_MODULE_12__/* ["default"].error */ .ZP.error('Sorry Something Went Wrong!');
          }
        });
      },
      validateMessages: validateMessages,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(FormItem, _objectSpread(_objectSpread({}, formItemLayout), {}, {
        label: "Email Address",
        name: "email",
        rules: [{
          required: true,
          type: 'email'
        }],
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(antd__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
          addonBefore: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {}),
          placeholder: "john.doe@gmail.com",
          autoComplete: "off",
          autoFocus: true,
          onChange: function onChange(e) {
            setuserEmail(e.target.value);
          }
        })
      })), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(FormItem, _objectSpread(_objectSpread({}, formItemLayout), {}, {
        name: "password",
        label: "Password",
        rules: [{
          required: true,
          message: 'Please input your Password!'
        }],
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(antd__WEBPACK_IMPORTED_MODULE_13__/* ["default"].Password */ .Z.Password, {
          addonBefore: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {}),
          placeholder: "Password",
          onChange: function onChange(e) {
            setuserPassword(e.target.value);
          }
        })
      })), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(FormItem, _objectSpread(_objectSpread({
        className: "m-b-0"
      }, formItemLayout), {}, {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_shared_button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
          type: "primary",
          size: "middle",
          icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {}),
          className: "auth--button--login",
          htmlType: "submit",
          source: "email-login",
          children: "Login Now"
        })
      }))]
    }))
  });
}

/***/ }),

/***/ 90635:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SocialLink; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62307);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24126);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71230);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15746);
/* harmony import */ var _shared_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);








var _getConfig = next_config__WEBPACK_IMPORTED_MODULE_1___default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var providersIcon = {
  facebook: {
    icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
    label: "SignIn with Facebook"
  },
  google: {
    icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
    label: "SignIn with Google"
  }
};
function SocialLink() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(antd__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    className: "linksContainer",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(antd__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
      span: "24",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: "socialLinkContainer",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_shared_button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
          type: "primary",
          href: "".concat(publicRuntimeConfig.cmsRootUrl, "/api/connect/facebook"),
          style: {
            width: '100%'
          },
          className: "facebook",
          source: "facebook-login",
          children: [providersIcon.facebook.icon, providersIcon.facebook.label]
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: "socialLinkContainer",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_shared_button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
          href: "".concat(publicRuntimeConfig.cmsRootUrl, "/api/connect/google"),
          type: "primary",
          style: {
            width: '100%'
          },
          className: "google",
          source: "google-login",
          children: [providersIcon.google.icon, providersIcon.google.label]
        })
      })]
    })
  });
}

/***/ }),

/***/ 62046:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ CreateFaq; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css
var react_draft_wysiwyg = __webpack_require__(49552);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(28860);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/antd/es/steps/index.js + 26 modules
var steps = __webpack_require__(19832);
// EXTERNAL MODULE: ./node_modules/antd/es/select/index.js + 34 modules
var es_select = __webpack_require__(67527);
// EXTERNAL MODULE: ./node_modules/antd/es/typography/index.js + 20 modules
var typography = __webpack_require__(51945);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 4 modules
var message = __webpack_require__(2453);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/antd/es/divider/index.js + 1 modules
var divider = __webpack_require__(96074);
// EXTERNAL MODULE: ./node_modules/antd/es/form/index.js + 20 modules
var es_form = __webpack_require__(50261);
// EXTERNAL MODULE: ./node_modules/antd/es/input/index.js + 7 modules
var input = __webpack_require__(42561);
// EXTERNAL MODULE: ./components/auth/EmailLogin.tsx
var EmailLogin = __webpack_require__(24414);
// EXTERNAL MODULE: ./components/auth/SocialLink.tsx
var SocialLink = __webpack_require__(90635);
// EXTERNAL MODULE: ./components/shared/button/index.tsx
var shared_button = __webpack_require__(61373);
// EXTERNAL MODULE: ./contexts/authStatus.ts
var authStatus = __webpack_require__(25595);
// EXTERNAL MODULE: ./node_modules/draft-js/lib/Draft.js
var Draft = __webpack_require__(9041);
// EXTERNAL MODULE: ./node_modules/draftjs-to-html/lib/draftjs-to-html.js
var draftjs_to_html = __webpack_require__(89265);
var draftjs_to_html_default = /*#__PURE__*/__webpack_require__.n(draftjs_to_html);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./graphql/generated/types.tsx
var types = __webpack_require__(13492);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/article/createPost.tsx




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


















var createPost_steps = {
  'Login/Register': 0,
  'Create Post': 1,
  Done: 2
};
var Editor = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 6925).then(__webpack_require__.t.bind(__webpack_require__, 35108, 23)).then(function (mod) {
    return mod.Editor;
  });
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(35108)];
    }
  }
});
var Step = steps/* default.Step */.Z.Step;
var Option = es_select/* default.Option */.Z.Option;
var Paragraph = typography/* default.Paragraph */.Z.Paragraph,
    Title = typography/* default.Title */.Z.Title;
function NewPost(props) {
  var categories = props.categories;
  var router = (0,next_router.useRouter)();

  var _useState = (0,react.useState)(createPost_steps['Login/Register']),
      current = _useState[0],
      setCurrent = _useState[1];

  var _useState2 = (0,react.useState)(null),
      currentUserToken = _useState2[0],
      setCurrentUserToken = _useState2[1];

  var _useState3 = (0,react.useState)(Draft.EditorState.createEmpty()),
      editorState = _useState3[0],
      setEditorState = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      contentErr = _useState4[0],
      setContentErr = _useState4[1];

  var _useState5 = (0,react.useState)(null),
      countryId = _useState5[0],
      setCountryId = _useState5[1]; // @ts-ignore


  var _useContext = (0,react.useContext)(authStatus/* default */.Z),
      setLogin = _useContext.setLogin;

  var country_slug = router.query.country_slug;
  (0,react.useEffect)(function () {
    if (localStorage.authToken) {
      setCurrentUserToken(localStorage.authToken);
      setCurrent(createPost_steps['Create Post']);
    }

    switch (country_slug) {
      case 'ca':
        setCountryId(2);
        break;

      case 'us':
        setCountryId(4);
        break;

      default:
        setCountryId(1);
    }
  }, []);

  var _useMutation = (0,useMutation/* useMutation */.D)(types/* CreateBlogDocument */.Um, {
    context: {
      headers: {
        Authorization: "Bearer ".concat(currentUserToken)
      }
    }
  }),
      _useMutation2 = (0,slicedToArray/* default */.Z)(_useMutation, 1),
      AddFaq = _useMutation2[0];

  var onEditorStateChange = function onEditorStateChange(editorData) {
    setEditorState(editorData);
    var checkData = editorData.getCurrentContent().hasText();

    if (!checkData) {
      setContentErr(true);
    } else {
      setContentErr(false);
    }
  };

  var submitQuery = function submitQuery(values, editorData) {
    AddFaq({
      variables: {
        data: {
          slug: values.title,
          title: values.title,
          short_description: values.short_description,
          user: localStorage.userId,
          tags: values.tags,
          article_type: 'blog',
          description: editorData,
          country: countryId
        }
      }
    }).then(function () {
      message/* default.info */.ZP.info('Your post is submitted for Review');
      setCurrent(createPost_steps.Done);
    })["catch"](function (e) {
      message/* default.error */.ZP.error(e.message);
    });
  };

  var sumbitContentCallback = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setLogin(true);
              _context.next = 3;
              return setCurrentUserToken(localStorage.authToken);

            case 3:
              message/* default.info */.ZP.info('Successfully Logged In!');
              router.push("/".concat([country_slug], "/create-post"));

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function sumbitContentCallback() {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
    className: "page-wrapper page",
    style: {
      justifyContent: 'center',
      display: 'flex'
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, {
      xs: 24,
      lg: 12,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(steps/* default */.Z, {
        progressDot: true,
        current: current,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Step, {
          title: "Login/Register",
          description: "please login/register to post your blog"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Step, {
          title: "Create your Post",
          description: "Please type your investment related post."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Step, {
          title: "Done"
        })]
      }), current === createPost_steps['Login/Register'] && /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
        className: "authPage",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, {
            span: "24",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
              className: "headerDescription",
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, {
                span: "24",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
                  level: 2,
                  children: "Login to your Account."
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
                  children: "Please enter your details to login."
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
              className: "formContainer",
              style: {
                marginTop: '32px'
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
                span: "24",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
                  className: "row",
                  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(col/* default */.Z, {
                    span: "24",
                    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SocialLink/* default */.Z // callbackbeforeRedirect={() => sumbitContentCallback()}
                    , {}), /*#__PURE__*/(0,jsx_runtime.jsx)(divider/* default */.Z, {
                      children: "or"
                    }), /*#__PURE__*/(0,jsx_runtime.jsx)(EmailLogin/* default */.Z, {
                      callbackbeforeRedirect: function callbackbeforeRedirect() {
                        return sumbitContentCallback();
                      }
                    })]
                  })
                })
              })
            })]
          })
        })
      }), current === createPost_steps['Create Post'] && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        style: {
          flexDirection: 'column',
          marginTop: '40px'
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Formik */.J9, {
          initialValues: {
            title: '',
            short_description: '',
            tags: [],
            content: Draft.EditorState.createEmpty()
          },
          validate: function validate() {
            var errors = {};
            return errors;
          },
          onSubmit: function onSubmit(values, actions) {
            var _editorState$getCurre;

            var checkData = editorState === null || editorState === void 0 ? void 0 : (_editorState$getCurre = editorState.getCurrentContent()) === null || _editorState$getCurre === void 0 ? void 0 : _editorState$getCurre.hasText();

            if (checkData) {
              var contentState = editorState.getCurrentContent();
              var rawContentState = draftjs_to_html_default()((0,Draft.convertToRaw)(contentState));
              var editorData = JSON.stringify(rawContentState);
              submitQuery(values, editorData);
            } else {
              setContentErr(true);
            }

            actions.setSubmitting(false);
          },
          children: function children(_ref2) {
            var isSubmitting = _ref2.isSubmitting,
                errors = _ref2.errors,
                touched = _ref2.touched;
            return /*#__PURE__*/(0,jsx_runtime.jsxs)(formik_esm/* Form */.l0, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(es_form/* default.Item */.Z.Item, {
                label: "",
                name: "title",
                rules: [{
                  required: true,
                  message: 'Title is required'
                }],
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                  name: "title",
                  validate: function validate(value) {
                    return !value || value.length === 0 ? 'Required' : undefined;
                  },
                  children: function children(_ref3) {
                    var field = _ref3.field;
                    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      children: ["Title:", /*#__PURE__*/(0,jsx_runtime.jsx)(input/* default */.Z, _objectSpread({
                        id: "title",
                        placeholder: "Title"
                      }, field))]
                    });
                  }
                }), errors.title && touched.title && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  style: {
                    color: 'red'
                  },
                  children: errors.title
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(es_form/* default.Item */.Z.Item, {
                label: "",
                name: "short_description",
                rules: [{
                  required: true,
                  message: 'Short Description is required'
                }],
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                  name: "short_description",
                  validate: function validate(value) {
                    return !value || value.length === 0 ? 'Required' : undefined;
                  },
                  children: function children(_ref4) {
                    var field = _ref4.field;
                    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      children: ["Description:", /*#__PURE__*/(0,jsx_runtime.jsx)(input/* default */.Z, _objectSpread({
                        id: "short_description",
                        placeholder: "Short Description"
                      }, field))]
                    });
                  }
                }), errors.short_description && touched.short_description && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  style: {
                    color: 'red'
                  },
                  children: errors.short_description
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(es_form/* default.Item */.Z.Item, {
                label: "",
                name: "tags",
                rules: [{
                  required: true,
                  message: 'Please select an option'
                }],
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(formik_esm/* Field */.gN, {
                  name: "tags",
                  validate: function validate(value) {
                    return !value || value.length === 0 ? 'Required' : undefined;
                  },
                  children: function children(_ref5) {
                    var field = _ref5.field,
                        form = _ref5.form;
                    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                      children: ["Tags:", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)(es_select/* default */.Z, _objectSpread(_objectSpread({
                        mode: "multiple",
                        id: "tags",
                        placeholder: "Keywords to be tagged",
                        style: {
                          width: 200
                        },
                        rules: [{
                          required: true,
                          message: 'Please select an option'
                        }]
                      }, field), {}, {
                        onChange: function onChange(value) {
                          return form.setFieldValue('tags', value);
                        },
                        onBlur: function onBlur() {
                          return form.setFieldTouched('tags', true);
                        },
                        children: categories.map(function (category) {
                          return /*#__PURE__*/(0,jsx_runtime.jsx)(Option, {
                            value: category.attributes.name,
                            children: category.attributes.name
                          }, category.id);
                        })
                      }))]
                    });
                  }
                }), errors.tags && touched.tags && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  style: {
                    color: 'red'
                  },
                  children: "Required"
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(es_form/* default.Item */.Z.Item, {
                label: "Content",
                name: "content",
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Editor, {
                  editorState: editorState,
                  editorStyle: {
                    border: '1px solid',
                    height: '250px'
                  },
                  toolbarClassName: "toolbar-class",
                  wrapperClassName: "wrapper-class",
                  editorClassName: "editor-class",
                  onEditorStateChange: onEditorStateChange,
                  toolbar: {
                    options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign', 'colorPicker', 'link', 'embedded', 'emoji', 'image', 'history'],
                    inline: {
                      inDropdown: true
                    },
                    list: {
                      inDropdown: true
                    },
                    textAlign: {
                      inDropdown: true
                    },
                    link: {
                      inDropdown: true
                    },
                    history: {
                      inDropdown: true
                    },
                    image: {
                      urlEnabled: true,
                      uploadEnabled: true,
                      previewImage: true,
                      alt: {
                        present: false,
                        mandatory: false
                      }
                    }
                  }
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  style: {
                    color: 'red'
                  },
                  children: contentErr ? 'Required' : ''
                })]
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), /*#__PURE__*/(0,jsx_runtime.jsx)(shared_button/* default */.Z, {
                type: "primary",
                htmlType: "submit",
                source: "submit-query",
                loading: isSubmitting,
                children: "Submit for Review"
              })]
            });
          }
        })
      }), current === createPost_steps.Done && /*#__PURE__*/(0,jsx_runtime.jsx)(row/* default */.Z, {
        className: "authPage",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(col/* default */.Z, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            children: "Expert users on our site will approve your post soon"
          })
        })
      })]
    })
  });
}
// EXTERNAL MODULE: ./layouts/application.tsx + 4 modules
var application = __webpack_require__(8182);
;// CONCATENATED MODULE: ./pages/[country_slug]/create-post.tsx






var title = "Create Post";
var description = "Create Post";
var __N_SSG = true;
function CreateFaq(props) {
  var pageData = props.data;
  var allBrokers = pageData.all_brokers.data,
      navCalculators = pageData.nav_calculators.data,
      allCategories = pageData.all_categories.data,
      allPages = pageData.all_pages.data;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(application/* default */.Z, {
    allBrokers: allBrokers,
    navCalculators: navCalculators,
    allPages: allPages,
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: description
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(NewPost, {
      categories: allCategories
    })]
  });
}

/***/ }),

/***/ 61352:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[country_slug]/create-post",
      function () {
        return __webpack_require__(62046);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5407,2453,3229,7752,2913,1945,2769,7527,6568,2580,1609,6582,8182,3492,9774,2888,179], function() { return __webpack_exec__(61352); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);